"use client";

import {
  Toaster as ChakraToaster,
  createToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
} from "@chakra-ui/react";
import { AlertCircle, AlertTriangle, CheckCircle2 } from "lucide-react";

export const toaster = createToaster({
  placement: "top",
  pauseOnPageIdle: true,
});

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast) => (
          <Toast.Root
            width={{ md: "sm" }}
            bgColor={
              toast.type === "success"
                ? "semantic.background.inverted"
                : toast.type === "error"
                  ? "core.negative"
                  : toast.type === "warning"
                    ? "core.warning"
                    : "semantic.background.inverted"
            }
          >
            {toast.type === "loading" ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <>
                {toast.type === "success" ? (
                  <CheckCircle2 color="white" size="24px" />
                ) : toast.type === "error" ? (
                  <AlertCircle color="white" size="24px" />
                ) : toast.type === "warning" ? (
                  <AlertTriangle color="white" size="24px" />
                ) : (
                  <CheckCircle2 color="white" size="24px" />
                )}
              </>
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && (
                <Toast.Title textStyle="Label/Large" color="white">
                  {toast.title}
                </Toast.Title>
              )}
              {toast.description && (
                <Toast.Description textStyle="Paragraph/Medium" color="white">
                  {toast.description}
                </Toast.Description>
              )}
            </Stack>
            {toast.action && (
              <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
            )}
            {toast.meta?.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
